import { useTranslation } from 'react-i18next';
import { Icon } from '@sendible/design-system/src';
import { HeaderDropdownMenu, HeaderMenuItem, MenuDivider } from '../../index.styles';

type ReportDropdownMenuProps = {
  onDuplicate: () => void;
  onClose: () => void;
  onDelete: () => void;
};

export const ReportDropdownMenu = ({ onDuplicate, onClose, onDelete }: ReportDropdownMenuProps) => {
  const { t } = useTranslation('reports');

  return (
    <HeaderDropdownMenu>
      <HeaderMenuItem onClick={onDuplicate}>
        <Icon
          color="brandDark"
          name="medias"
        />
        <p>{t('new_reports_duplicate')}</p>
      </HeaderMenuItem>
      <HeaderMenuItem onClick={onClose}>
        <Icon
          color="brandDark"
          name="close_circle"
        />
        <p>{t('new_reports_close')}</p>
      </HeaderMenuItem>
      <MenuDivider />
      <HeaderMenuItem onClick={onDelete}>
        <Icon
          color="brandDark"
          name="trash"
        />
        <p>{t('new_reports_delete')}</p>
      </HeaderMenuItem>
    </HeaderDropdownMenu>
  );
};
